import type { Element, Props } from './element';

/**
 * 소자 생성기는 catalog.ts 가 로드될 때 등록한다.
 * (serial ← subckt ← catalog 순환 import 를 피하려고 늦게 묶는다)
 */
interface Factory {
  create: (type: string, x1: number, y1: number, x2: number, y2: number, props?: Props, id?: string) => Element;
  bumpIds: (ids: string[]) => void;
}
let factory: Factory | null = null;
export function registerElementFactory(f: Factory): void {
  factory = f;
}
function need(): Factory {
  if (!factory) throw new Error('소자 카탈로그가 아직 로드되지 않았어요');
  return factory;
}

/** 파일/모듈 정의에 저장되는 소자 한 개 */
export interface SerializedElement {
  id: string;
  type: string;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  props: Props;
}

export function serializeElements(list: Element[]): SerializedElement[] {
  return list.map((el) => ({
    id: el.id,
    type: el.type,
    x1: el.x1, y1: el.y1, x2: el.x2, y2: el.y2,
    props: { ...el.props },
  }));
}

/** 직렬화된 소자들을 실제 객체로. keepIds=false 면 새 id 를 발급한다 */
export function instantiateElements(list: SerializedElement[], keepIds = true): Element[] {
  const f = need();
  if (keepIds) f.bumpIds(list.map((e) => e.id));
  const out: Element[] = [];
  for (const e of list) {
    try {
      out.push(f.create(e.type, e.x1, e.y1, e.x2, e.y2, { ...e.props }, keepIds ? e.id : undefined));
    } catch (err) {
      console.warn('건너뛴 소자:', e.type, err);
    }
  }
  return out;
}
